import { Spinner } from '@fluentui/react-components';
import { createi18nTranslationBundle } from '@idmc-ms-fabric/common';
import useI18nInit from '@idmc-ms-fabric/common/src/i18next/useI18nInit';
import { FC, ReactNode, useEffect, useMemo, useState } from 'react';

import { i18nNamspaceBundleMap } from '../../../i18n';
import { LocalStorage } from '../../../utils/storage-utils';
import { isPseudoLocaleEnabled, LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY } from './I18n-utils';

const default_lang = 'en';
const supportedLangs = [default_lang];

const Initializei18n: FC<{ children?: ReactNode }> = ({ children }) => {
	const [isReady, setReady] = useState(false);
	const enablePseudoLocale = (): void => {
		const isPseudoEnabled = LocalStorage.get<boolean>(LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY);
		if (isPseudoEnabled) {
			console.info('pseudo chars already enabled');
			return;
		}
		LocalStorage.set<boolean>(LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY, true);
		setReady(false);
	};
	const disablePseudoLocale = (): void => {
		const isPseudoEnabled = LocalStorage.get<boolean>(LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY);
		if (!isPseudoEnabled) {
			console.info('pseudo chares already disabled');
			return;
		}
		LocalStorage.set<boolean>(LOCALSTORE_PSEUDO_LOCALE_ENABLE_KEY, false);
		setReady(false);
	};
	const isPseudoEnabled = useMemo(() => isPseudoLocaleEnabled(), [enablePseudoLocale, disablePseudoLocale]);

	const enablePseudoLocaleInBrowser = (): void => {
		window.fabric_data_quality = {
			locale: {
				enablePseudoLocale,
				disablePseudoLocale,
			},
			downloadLogs: window.fabric_data_quality?.downloadLogs,
		};
	};
	/**
	 * Initialize i18next instance.
	 */
	const i18nInstance = useI18nInit({
		fallbackLng: default_lang,
		debug: true,
		lng: default_lang,
		initImmediate: false,
	});
	/**
	 * Add translation bundles for data quality.
	 */
	const addBundles = async () => {
		for (const lang of supportedLangs) {
			const translations = await import(`../../../i18n/translations/${lang}.json`);
			Object.entries(i18nNamspaceBundleMap).forEach(([ns, bundle]) => {
				i18nInstance.addResourceBundle(
					lang,
					ns,
					createi18nTranslationBundle({
						bundle,
						translations,
						enablePseudo: isPseudoEnabled,
					}),
				);
			});
		}
		setReady(true);
	};

	useEffect(() => {
		if (i18nInstance) {
			addBundles();
			/**
			 * ! exposing function to set pseudo local
			 */
			enablePseudoLocaleInBrowser();
		}
	}, [i18nInstance, isReady]);
	return <>{isReady ? children : <Spinner style={{ height: '100%' }} />}</>;
};

export default Initializei18n;
